<template>
  <div class="relative min-h-screen">
    <!-- Background -->
    <div class="fixed inset-0 z-0 vault-gradient pointer-events-none"></div>

    <!-- Navbar -->
    <nav
      class="relative z-10 w-full px-6 lg:px-12 py-8 flex justify-between items-center"
    >
      <div class="flex items-center gap-3">
        <img src="/images/logo.png" style="height: 3.5rem;">
      </div>

      <div class="hidden md:flex items-center gap-6">
        <span
          class="text-[10px] font-bold uppercase tracking-widest text-slate-400"
        >
          Security Protocol v4.2
        </span>
        <div class="h-4 w-px bg-slate-200"></div>
        <a
          href="javascript:void()"
          @click="gotosignup()"
          class="text-sm font-semibold text-slate-600 hover:text-accent transition-colors"
        >
          Request Access
        </a>
      </div>
    </nav>

    <!-- Main -->
    <main
      class="relative z-10 flex-1 flex flex-col items-center justify-center px-6 pb-20"
    >
      <!-- Heading -->
      <div class="text-center mb-10 max-w-2xl">
        <h1
          class="text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tight mb-4"
        >
          Enter Your <span class="text-accent">Private Vault</span>
        </h1>
        <p class="text-lg text-slate-500 font-medium">
          Creator Intelligence & Audience Ownership
        </p>
      </div>

      <!-- Login Card -->
      <div class="login-gate w-full max-w-md rounded-xl p-8 md:p-10">
        <form class="space-y-8" @submit.prevent="login">
          <!-- Email -->
          <!-- Email -->
          <div class="space-y-3">
            <label
              class="block text-[11px] font-bold uppercase tracking-widest text-slate-500 ml-1"
            >
              Email Address
            </label>

            <div class="relative group">
              <div
                class="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none text-slate-400"
              >
                <i class='bx bx-at text-xl'></i>
              </div>

              <input
                v-model="email"
                type="email"
                placeholder="influencer@vault.io"
                @blur="validateEmail"
                class="w-full bg-slate-50/50 border rounded-lg py-4 pl-12 pr-4 text-lg font-medium outline-none transition-all placeholder:text-slate-300 input-focus-effect"
                :class="emailError ? 'border-red-400 focus:ring-red-200' : 'border-slate-100'"
              />
            </div>

            <p v-if="emailError" class="text-red-500 text-sm ml-1">
              {{ emailError }}
            </p>
          </div>

          <!-- Password -->
          <div class="space-y-3">
            <div class="flex justify-between items-center ml-1">
              <label
                class="block text-[11px] font-bold uppercase tracking-widest text-slate-500"
              >
                Vault Key
              </label>
              <a
                href="/forgot-password"
                class="text-[11px] font-bold text-accent hover:underline uppercase tracking-widest"
              >
                Lost Key?
              </a>
            </div>

            <div class="relative group">
              <div
                class="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none text-slate-400"
              >
              <i class='bx bx-lock text-xl'></i>
              </div>

              <input
                v-model="password"
                :type="showPassword ? 'text' : 'password'"
                placeholder="••••••••••••"
                class="w-full bg-slate-50/50 border border-slate-100 rounded-lg py-4 pl-12 pr-12 text-lg font-medium outline-none transition-all placeholder:text-slate-300 input-focus-effect"
              />

              <!-- Eye Icon -->
              <div
                class="absolute inset-y-0 right-0 pr-4 flex items-center cursor-pointer text-slate-400 hover:text-charcoal transition-colors"
                @click="showPassword = !showPassword"
              >
               <i class='bx text-xl' :class="showPassword ? 'bx-hide' : 'bx-show'"></i>
              </div>
            </div>
          </div>
          <button
              type="submit"
              :disabled="loading"
              class="w-full bg-primary hover:bg-black text-white font-bold py-5 rounded-lg text-lg transition-all active:scale-[0.98] shadow-lg shadow-primary/10 flex items-center justify-center gap-2 group disabled:opacity-50"
            >
              <span v-if="!loading">Enter Dashboard</span>
              <span v-else>Authorizing...</span>

             <i class='bx bx-right-arrow-alt text-xl group-hover:translate-x-1 transition-transform'></i>
            </button>
            <!-- Divider -->
            <div class="flex items-center gap-3 my-6">
              <div class="flex-1 h-px bg-slate-200"></div>
              <span class="text-xs text-slate-400 font-semibold uppercase tracking-widest">
                Or continue with
              </span>
              <div class="flex-1 h-px bg-slate-200"></div>
            </div>

            <!-- Google Login -->
            <button
              type="button"
              @click="googleLogin"
              class="w-full flex items-center justify-center gap-3 border border-slate-200 bg-white hover:bg-slate-50 py-4 rounded-lg text-sm font-semibold transition-all shadow-sm"
            >
              <img
                src="/images/google.png"
                class="w-5 h-5"
              />

              Continue with Google
            </button>
        </form>
        

        <!-- Signup hint -->
        <div class="mt-6 text-center text-sm text-slate-500 font-medium">
          Don’t have access?
          <a
            @click="gotosignup()"
            class="font-bold text-accent hover:underline ml-1"
          >
            Request an invite
          </a>
        </div>

        <!-- Footer inside card -->
        <div
          class="mt-10 pt-8 border-t border-slate-50 flex justify-center"
        >
          <div class="flex items-center gap-2 text-slate-400 text-xs font-medium">
            <i class='bx bx-check-shield text-sm'></i>
            End-to-end encrypted session
          </div>
        </div>
      </div>

      <!-- Page Footer -->
      <footer
        class="absolute bottom-8 text-slate-400 text-[10px] uppercase tracking-[0.2em] font-bold"
      >
        © 2024 Creator Intelligence Systems • Established 2021
      </footer>
    </main>
  </div>
</template>
<script>
import { useToast } from "vue-toastification";
import { loginApi } from "../apis/authapis";
import { apiBaseUrl } from "@/apis/appconst";
import { useRoute } from "vue-router";

export default {

  name: "LoginScreen",

  data() {
    return {

      email: "",
      password: "",
      loading: false,

      showPassword: false,
      emailError: "",

      toast: null,
      inf:"",
      mutype:"influencer",
      isJoin:false
    };
  },

  mounted() {
    this.toast = useToast();
    var router = useRoute();
     const udata = router.query.udata;
    //  const rtype = router.query.rtype;
    if (udata) {
      const ldata = atob(udata);
      if (ldata.length > 0) {
        
        sessionStorage.setItem("ldata", ldata);
        window.location.href = "/";
      }
    }
     this.inf = router.query.inf || "";
     this.mutype = router.query.utype || "influencer";
     if(this.inf && this.inf.length>0){
      this.isJoin = true;
     }
    //  alert(this.isJoin+"");
  },

  methods: {
    gotosignup(){
      sessionStorage.removeItem("udata");
      window.location.href = "/signup?utype="+this.mutype;
    },
    validateEmail() {

      const emailRegex =
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

      if (!this.email.trim()) {
        this.emailError = "Email is required";
        return false;
      }

      if (!emailRegex.test(this.email)) {
        this.emailError = "Please enter a valid email address";
        return false;
      }

      this.emailError = "";
      return true;
    },

    async googleLogin() {

      window.location.href = apiBaseUrl + "google_login?utype="+this.mutype;

    },
    
    async login() {

      if (!this.validateEmail()) return;

      if (!this.email.trim()) {
        this.toast.error("Email is required");
        return;
      }

      if (!this.password.trim()) {
        this.toast.error("Vault key is required");
        return;
      }

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (!emailRegex.test(this.email)) {
        this.toast.error("Invalid email format");
        return;
      }

      this.loading = true;

      const res = await loginApi(this.email, this.password,this.inf);

      this.loading = false;

      if (!res.status) {

        this.toast.error(res.success || "Login failed");
        return;
      }

      this.toast.success(res.success || "Login successful");

      // Store session
      sessionStorage.setItem("ldata", JSON.stringify(res.user));

      // Redirect
      if(this.isJoin){
        window.location.href = "/user/following";
      }
      else{
        window.location.href = "/";
      }
    }

  }
};
</script>

